import Avatar from "hardcover-ui/components/Avatar";
import { AvatarThemeProps } from "hardcover-ui/theme/components/avatar";
import useCurrentUser from "hooks/fragments/useCurrentUser";

export default function CurrentUserAvatar({
  size = "md",
  isLink = false,
}: {
  size: AvatarThemeProps["size"];
  isLink?: boolean;
}) {
  const image = useCurrentUser(u => u.image);

  return (
    <Avatar
      size={size}
      image={image}
      alt="Your Avatar"
      lazy={false}
      isLink={isLink}
    />
  );
}
